<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">You will need:</p>
      <ul class="default-list">
        <li>a pen and paper</li>
        <li>A phone to time yourself</li>
      </ul>

      <p class="mb-5">
        As mentioned in the learning and resources section, The Stanislavski Technique is used to
        help the actor put themselves in the character’s shoes and empathise with them.
      </p>
      <p class="mb-5">
        You will be using Stanislavski’s method to improvise and act out some short scenarios
        thinking about the following:
      </p>

      <ol class="numbered-list">
        <li>Who Am I?</li>
        <li>Where Am I?</li>
        <li>When Is It?</li>
        <li>What Do I Want?</li>
        <li>Why Do I Want It?</li>
        <li>How Will I Get It?</li>
        <li>What Do I Need To Overcome?</li>
      </ol>

      <p class="mb-5">
        <strong>Scenario 1:</strong> You are getting ready to go out to a party, you are in a hurry.
        What would you do if there was a power cut?
      </p>
      <p class="mb-5">
        <strong>Step 1:</strong> Think about the seven questions in Stanislavski’s technique and
        write down your answers. You can make up any character and scenario you like.
      </p>
      <textarea-block v-model="data.question1" :editable="isEditable" />
      <p class="mb-5">
        <strong>Step 2:</strong> Using your phone to time yourself, act out a 5 minute scene
        according to Stanislavski’s technique.
      </p>
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="video"
        index="1"
        key="1"
      />

      <p class="mb-5">
        <strong>Scenario 2:</strong> You are at the checkout with a week's worth of shopping. What
        would you do if you realised you have no money?
      </p>
      <p class="mb-5">
        <strong>Step 1:</strong> Think about the seven questions in Stanislavski’s technique and
        write down your answers. You can make up any character and scenario you like.
      </p>
      <textarea-block v-model="data.question2" :editable="isEditable" />
      <p class="mb-5">
        <strong>Step 2:</strong> Using your phone to time yourself, act out a 5 minute scene
        according to Stanislavski’s technique.
      </p>
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_2']"
        :is-editable="isEditable"
        filetype="video"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      uploaded_files: {
        uploaded_file_1: '',
        uploaded_file_2: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
